// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"58027e02a201d865c594","4057":"6e6bf1e808e95bdecb25","5771":"d141d1ad8187d99738b9","5810":"8dfb2392d7107957a510","5862":"142cd48ca8ec32e57725","7471":"6423b9b898ffefeb7d1d"}[chunkId] + "";
};